import { Field } from 'formik';
import React, { useState } from 'react';
import {
  CustomInput,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
} from 'reactstrap';
import '../my-profile/about-me/aboutme.scss';
import './customFormComponents.scss';
import '../../container/my-rentals/rentals.scss';

const FormInputWrapper = ({
  label,
  id,
  showError,
  error,
  children,
  ...other
}) => {
  return (
    <FormGroup>
      {label ? (
        <Label for={id} {...other} className={'label-text'}>
          {label}
        </Label>
      ) : null}
      <div>
        {children}
        {showError && (
          <div
            className='invalid-feedback d-block label-text'
            style={{ fontFamily: 'Brown' }}
          >
            {error}
          </div>
        )}
      </div>
    </FormGroup>
  );
};

const CommonFormInput = ({
  label,
  name,
  id,
  type,
  showError,
  error,
  placeholder,
  style,
}) => (
  <FormInputWrapper label={label} id={id} showError={showError} error={error}>
    <Field
      type={type}
      name={name}
      id={id}
      className='form-control label-text'
      placeholder={placeholder || ''}
      style={style ? style : { borderRadius: 30 }}
    />
  </FormInputWrapper>
);

const SelectFormInput = ({
  label,
  name,
  id,
  options,
  showError,
  error,
  showEmpty,
  selectTitle,
}) => {
  return (
    <FormInputWrapper label={label} id={id} showError={showError} error={error}>
      <Field
        as='select'
        name={name}
        id={id}
        className='form-control label-text'
        style={{ borderRadius: 30 }}
      >
        {showEmpty && <option value='' disabled>{selectTitle || '-- select --'}</option>}
        {options.map((opt, index) => (
          <option value={opt.value} key={`${name}_${index}`}>
            {opt.label ? opt.label : opt.display}
          </option>
        ))}
      </Field>
    </FormInputWrapper>
  );
};

const CommonFormInputGroup = ({
  label,
  showError,
  error,
  prepend,
  append,
  ...other
}) => {
  const [isFocus, setIsFocus] = useState(false);
  return (
    <FormInputWrapper
      label={label}
      id={other.id}
      showError={showError}
      error={error}
    >
      <InputGroup className='extended-input-group label-text'>
        {prepend && (
          <InputGroupAddon addonType='prepend'>
            <span
              className={
                isFocus ? 'prepand-append-input-focus' : 'prepand-append-input'
              }
            >
              {prepend}
            </span>
          </InputGroupAddon>
        )}
        <Field
          {...other}
          className='extended-input right extended-input left extended-input left form-control label-text'
          onFocus={() => setIsFocus(true)}
          onBlur={() => setIsFocus(false)}
        />

        {append && (
          <InputGroupAddon addonType='append'>
            <span
              className={
                isFocus ? 'prepand-append-input-focus' : 'prepand-append-input'
              }
            >
              {append}
            </span>
          </InputGroupAddon>
        )}
      </InputGroup>
    </FormInputWrapper>
  );
};

const FormikCustomRadioGroup = ({
  name,
  value,
  options,
  inline = false,
  onChange,
  onBlur,
}) => {
  const handleChange = (val) => {
    onChange(name, val);
  };

  const handleBlur = () => {
    onBlur(name, true);
  };

  return (
    <>
      {options.map((child, index) => {
        return (
          <CustomInput
            key={`${name}_${child.value}_${index}`}
            type='radio'
            id={`${name}_${child.value}_${index}`}
            name={name}
            label={child.label}
            onChange={() => handleChange(child.value)}
            onBlur={handleBlur}
            checked={value === child.value}
            disabled={child.disabled}
            inline={inline}
            className={'label-text'}
          />
        );
      })}
    </>
  );
};

const CommonFormRadioGroup = ({
  label,
  id,
  name,
  value,
  onChange,
  onBlur,
  options,
  showError,
  error,
  notInline,
}) => (
  <FormInputWrapper
    className={'label-text'}
    label={label}
    id={id}
    showError={showError}
    error={error}
  >
    <FormikCustomRadioGroup
      className={'label-text'}
      name={name}
      id={id}
      value={value}
      onChange={onChange}
      options={options}
      onBlur={onBlur}
      inline={notInline ? false : true}
    />
  </FormInputWrapper>
);

const CustomCheckBox = ({
  value,
  id,
  title,
  checked,
  onCheckChange,
  disabled,
  ...otherProps
}) => {
  return (
    <div className='d-flex align-items-center' {...otherProps}>
      <input
        type='checkbox'
        id={id}
        name={id}
        value={value}
        className={'regular-checkbox mr-3'}
        checked={checked}
        disabled={disabled}
        onChange={(e) => {
          if (onCheckChange) {
            onCheckChange(e.target.checked);
          }
        }}
      />
      {title ? (
        <span for={id} className={'mb-0'} style={{ fontSize: 14 }}>
          {title}
        </span>
      ) : null}
    </div>
  );
};
export {
  FormInputWrapper,
  CommonFormInputGroup,
  CommonFormInput,
  SelectFormInput,
  FormikCustomRadioGroup,
  CommonFormRadioGroup,
  CustomCheckBox,
};
